import checkPWAMethods from '~/utils/checkPWAMethods';
import { useWebsiteStore } from '~/stores/websiteStore';

export const useInitTabBar = function () {
  const websiteStore = useWebsiteStore();
  const route = useRoute();

  /**
   * debug tab bar
   */
  if (!import.meta.dev) {
    if (route.query.test === '1') websiteStore.showTabBar = true;

  } else {
    websiteStore.showTabBar = true;
  }

  onMounted(() => {
    if (checkPWAMethods()) {
      websiteStore.showTabBar = true;
    }
  });

  return {};
};
